/** Stored upload + parse state of an import; the lifecycle shown to the user is `FecImportLifecycleStatus`. */
export enum FecImportProcessingStatus {
  AwaitingProcessing = 'awaiting_processing',
  Parsed = 'parsed',
  Parsing = 'parsing',
  ParsingFailed = 'parsing_failed',
}
